<template>
  <div class="app-container">
    <!-- 搜索筛选区域 -->
    <div class="filter-container">
      <el-form inline size="small">
        <el-form-item label="酒店名称">
          <el-input
            v-model="listQuery.hotel_name"
            placeholder="模糊查询"
            clearable
            style="width: 150px"
          />
        </el-form-item>
        <el-form-item label="API账号ID">
          <el-input
            v-model="listQuery.api_account_id"
            placeholder="精确查询"
            clearable
            style="width: 100px"
            type="number"
          />
        </el-form-item>
        <el-form-item label="价格方案ID">
          <el-input
            v-model="listQuery.price_plan_id"
            placeholder="精确查询"
            clearable
            style="width: 100px"
            type="number"
          />
        </el-form-item>
        <el-form-item label="分销商订单号">
          <el-input
            v-model="listQuery.distributor_res_id"
            placeholder="精确查询"
            clearable
            style="width: 140px"
          />
        </el-form-item>
        <el-form-item label="CRS订单号">
          <el-input
            v-model="listQuery.crs_order_no"
            placeholder="精确查询"
            clearable
            style="width: 140px"
            type="number"
          />
        </el-form-item>
        <el-form-item label="订单状态">
          <el-input
            v-model="listQuery.crs_order_status"
            placeholder="精确查询"
            clearable
            style="width: 100px"
          />
        </el-form-item>
        <el-form-item label="丽呈酒店ID">
          <el-input
            v-model="listQuery.hotel_id"
            placeholder="精确查询"
            clearable
            style="width: 100px"
            type="number"
          />
        </el-form-item>
        <el-form-item label="房型ID">
          <el-input
            v-model="listQuery.roomtyp_id"
            placeholder="精确查询"
            clearable
            style="width: 100px"
            type="number"
          />
        </el-form-item>
        <el-form-item label="产品ID">
          <el-input
            v-model="listQuery.product_id"
            placeholder="精确查询"
            clearable
            style="width: 100px"
            type="number"
          />
        </el-form-item>
        <el-form-item label="价格ID">
          <el-input
            v-model="listQuery.rate_id"
            placeholder="精确查询"
            clearable
            style="width: 100px"
            type="number"
          />
        </el-form-item>
        <el-form-item label="入住日期">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            style="width: 240px"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleFilter">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格区域 -->
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      stripe
      size="small"
    >
      <el-table-column label="ID" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column label="API账号ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.api_account_id }}
        </template>
      </el-table-column>

      <el-table-column label="价格方案ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.price_plan_id }}
        </template>
      </el-table-column>

      <el-table-column label="CRS订单号" min-width="140" align="center">
        <template slot-scope="scope">
          {{ scope.row.crs_order_no }}
        </template>
      </el-table-column>

      <el-table-column label="分销商订单号" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.distributor_res_id }}
        </template>
      </el-table-column>

      <el-table-column label="丽呈酒店ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.hotel_id }}
        </template>
      </el-table-column>

      <el-table-column label="酒店编码" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.hotel_code }}
        </template>
      </el-table-column>

      <el-table-column label="酒店名称" min-width="180" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ (scope.row.hotel && scope.row.hotel.hotel_name) || '-' }}
        </template>
      </el-table-column>

      <el-table-column label="托管模式" min-width="100" align="center">
        <template slot-scope="scope">
          {{ formatPlanMode(scope.row.price_plan && scope.row.price_plan.mode) }}
        </template>
      </el-table-column>

      <el-table-column label="公司/企业等级" min-width="140" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.company_name || scope.row.company_id || scope.row.corp_level_code || '-' }}
        </template>
      </el-table-column>

      <el-table-column label="房型ID" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.roomtyp_id }}
        </template>
      </el-table-column>

      <el-table-column label="产品ID" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.product_id }}
        </template>
      </el-table-column>

      <el-table-column label="价格ID" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.rate_id }}
        </template>
      </el-table-column>

      <el-table-column label="入住日期" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.check_in_date }}
        </template>
      </el-table-column>

      <el-table-column label="离店日期" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.check_out_date }}
        </template>
      </el-table-column>

      <el-table-column label="房间数" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.room_quantity }}
        </template>
      </el-table-column>

      <el-table-column label="总金额" min-width="120" align="center">
        <template slot-scope="scope">
          {{
            formatAmount(scope.row.total_amount)
          }}
        </template>
      </el-table-column>

      <el-table-column label="实付金额" min-width="120" align="center">
        <template slot-scope="scope">
          {{
            formatAmount(scope.row.total_pay_amount)
          }}
        </template>
      </el-table-column>

      <el-table-column label="联系人" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.contact_name }}
        </template>
      </el-table-column>

      <el-table-column label="联系电话" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.contact_phone }}
        </template>
      </el-table-column>

      <el-table-column label="订单状态" min-width="100" align="center">
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.crs_order_status === 'N'"
            type="info"
            size="mini"
            >待确认</el-tag
          >
          <el-tag
            v-else-if="scope.row.crs_order_status === 'A'"
            type="success"
            size="mini"
            >已确认</el-tag
          >
          <el-tag
            v-else-if="scope.row.crs_order_status === 'NS'"
            type="warning"
            size="mini"
            >未到</el-tag
          >
          <el-tag
            v-else-if="scope.row.crs_order_status === 'C'"
            type="primary"
            size="mini"
            >已入住</el-tag
          >
          <el-tag
            v-else-if="scope.row.crs_order_status === 'F'"
            type="success"
            size="mini"
            >已离店</el-tag
          >
          <el-tag
            v-else-if="scope.row.crs_order_status === 'E'"
            type="danger"
            size="mini"
            >已取消</el-tag
          >
          <span v-else>{{ scope.row.crs_order_status || '-' }}</span>
        </template>
      </el-table-column>

      <el-table-column label="创建时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>

      <el-table-column label="更新时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.updated_at }}
        </template>
      </el-table-column>

      <el-table-column label="其他" min-width="80" align="center">
        <template slot-scope="scope">
          <span v-if="hasExtraData(scope.row)">...</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <!-- 操作列 -->
      <el-table-column
        label="操作"
        min-width="200"
        align="center"
        fixed="right"
      >
        <template slot-scope="scope">
          <div class="operation-buttons">
            <el-button type="warning" size="mini" @click="syncOrder(scope.row)"
              >同步订单</el-button
            >
            <el-button
              type="warning"
              size="mini"
              @click="cancelOrder(scope.row)"
              :disabled="scope.row.crs_order_status === 'E'"
              >取消订单</el-button
            >
            <el-button
              type="primary"
              size="mini"
              @click="handleViewDetail(scope.row)"
            >
              查看详情
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页区域 -->
    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- 查看详情弹窗 -->
    <el-dialog
      title="订单详情"
      :visible.sync="dialogDetailVisible"
      width="900px"
      :close-on-click-modal="true"
    >
      <div class="detail-content">
        <el-descriptions :column="2" border size="small">
          <el-descriptions-item label="CRS订单号">
            {{ currentRow.crs_order_no || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="分销商订单号">
            {{ currentRow.distributor_res_id || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="API账号ID">
            {{ currentRow.api_account_id || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="价格方案ID">
            {{ currentRow.price_plan_id || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="分组ID">
            {{ currentRow.group_id || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="丽呈酒店ID">
            {{ currentRow.hotel_id || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="酒店编码">
            {{ currentRow.hotel_code || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="协议公司ID">
            {{ currentRow.company_id || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="下单公司名称">
            {{ currentRow.company_name || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="企业等级编码">
            {{ currentRow.corp_level_code || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="房型ID">
            {{ currentRow.roomtyp_id || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="产品ID">
            {{ currentRow.product_id || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="价格ID">
            {{ currentRow.rate_id || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="入住日期">
            {{ currentRow.check_in_date || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="离店日期">
            {{ currentRow.check_out_date || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="房间数量">
            {{ currentRow.room_quantity || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="总金额">
            {{
              formatAmount(currentRow.total_amount, '无')
            }}
          </el-descriptions-item>
          <el-descriptions-item label="实付金额">
            {{
              formatAmount(currentRow.total_pay_amount, '无')
            }}
          </el-descriptions-item>
          <el-descriptions-item label="联系人">
            {{ currentRow.contact_name || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="联系电话">
            {{ currentRow.contact_phone || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="订单状态">
            <el-tag
              v-if="currentRow.crs_order_status === 'N'"
              type="info"
              size="mini"
              >待确认</el-tag
            >
            <el-tag
              v-else-if="currentRow.crs_order_status === 'A'"
              type="success"
              size="mini"
              >已确认</el-tag
            >
            <el-tag
              v-else-if="currentRow.crs_order_status === 'NS'"
              type="warning"
              size="mini"
              >未到</el-tag
            >
            <el-tag
              v-else-if="currentRow.crs_order_status === 'C'"
              type="primary"
              size="mini"
              >已入住</el-tag
            >
            <el-tag
              v-else-if="currentRow.crs_order_status === 'F'"
              type="success"
              size="mini"
              >已离店</el-tag
            >
            <el-tag
              v-else-if="currentRow.crs_order_status === 'E'"
              type="danger"
              size="mini"
              >已取消</el-tag
            >
            <span v-else>{{ currentRow.crs_order_status || '无' }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="创建时间">
            {{ currentRow.created_at || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="更新时间">
            {{ currentRow.updated_at || '无' }}
          </el-descriptions-item>
        </el-descriptions>

        <div class="json-section">
          <div class="json-label">关联酒店对象：</div>
          <div v-if="currentRow.hotel" class="json-content">
            <pre>{{ formatJson(currentRow.hotel) }}</pre>
          </div>
          <div v-else class="json-empty">无</div>
        </div>

        <div class="json-section">
          <div class="json-label">关联价格方案对象：</div>
          <div v-if="currentRow.price_plan" class="json-content">
            <pre>{{ formatJson(currentRow.price_plan) }}</pre>
          </div>
          <div v-else class="json-empty">无</div>
        </div>

        <div class="json-section">
          <div class="json-label">关联API账号对象：</div>
          <div v-if="currentRow.api_account" class="json-content">
            <pre>{{ formatJson(currentRow.api_account) }}</pre>
          </div>
          <div v-else class="json-empty">无</div>
        </div>

        <div class="json-section">
          <div class="json-label">关联系统订单对象：</div>
          <div v-if="currentRow.system_order" class="json-content">
            <pre>{{ formatJson(currentRow.system_order) }}</pre>
          </div>
          <div v-else class="json-empty">无</div>
        </div>

        <div class="json-section">
          <div class="json-label">原始请求JSON：</div>
          <div v-if="currentRow.raw_request" class="json-content">
            <pre>{{ formatJson(currentRow.raw_request) }}</pre>
          </div>
          <div v-else class="json-empty">无</div>
        </div>

        <div class="json-section">
          <div class="json-label">原始响应JSON：</div>
          <div v-if="currentRow.raw_response" class="json-content">
            <pre>{{ formatJson(currentRow.raw_response) }}</pre>
          </div>
          <div v-else class="json-empty">无</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogDetailVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import { formatLiChengAmount } from '@/utils/licheng'

export default {
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      // 搜索参数
      listQuery: {
        page: 1,
        limit: 10,
        hotel_name: undefined,
        api_account_id: undefined,
        price_plan_id: undefined,
        distributor_res_id: undefined,
        crs_order_no: undefined,
        crs_order_status: undefined,
        hotel_id: undefined,
        roomtyp_id: undefined,
        product_id: undefined,
        rate_id: undefined,
        start_date: undefined,
        end_date: undefined,
        sort: 'id',
        order: 'DESC',
      },
      // 日期范围
      dateRange: null,
      // 查看详情弹窗
      dialogDetailVisible: false,
      currentRow: {},
    }
  },
  created() {
    this.getList()
  },
  methods: {
    formatAmount(value, emptyText = '-') {
      return formatLiChengAmount(value, emptyText)
    },
    formatPlanMode(mode) {
      return {
        direct: '双方托管',
        corp_level: '三方托管',
        company_id: '公司ID（停用）',
      }[mode] || mode || '-'
    },
    syncOrder(row) {
      this.$confirm('确认继续该操作', '提示', {
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/liCheng/order/syncOrder',
            method: 'post',
            data: {
              order_id: row.id,
            },
          }).then(() => {
            this.getList()
            this.$message({
              type: 'success',
              message: '操作成功',
            })
          })
        })
        .catch(() => {})
    },
    cancelOrder(row) {
      this.$confirm('确认继续该操作', '提示', {
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/liCheng/order/cancelOrder',
            method: 'post',
            data: {
              order_id: row.id,
            },
          }).then(() => {
            this.getList()
            this.$message({
              type: 'success',
              message: '操作成功',
            })
          })
        })
        .catch(() => {})
    },
    // 判断是否有额外数据
    hasExtraData(row) {
      return (
        row.raw_request ||
        row.raw_response ||
        row.hotel ||
        row.price_plan ||
        row.api_account ||
        row.system_order
      )
    },
    // 格式化JSON字符串
    formatJson(jsonStr) {
      if (!jsonStr) return ''
      try {
        if (typeof jsonStr === 'object') {
          return JSON.stringify(jsonStr, null, 2)
        }
        const parsed = JSON.parse(jsonStr)
        return JSON.stringify(parsed, null, 2)
      } catch (e) {
        return jsonStr
      }
    },
    // 获取列表数据
    getList() {
      this.listLoading = true

      // 处理日期范围
      if (this.dateRange && this.dateRange.length === 2) {
        this.listQuery.start_date = this.dateRange[0]
        this.listQuery.end_date = this.dateRange[1]
      } else {
        this.listQuery.start_date = undefined
        this.listQuery.end_date = undefined
      }

      // 处理空值参数
      const params = {}
      Object.keys(this.listQuery).forEach((key) => {
        const val = this.listQuery[key]
        if (val !== '' && val !== undefined && val !== null) {
          params[key] = val
        }
      })

      request({
        url: '/api/backend/liCheng/order/orderList',
        method: 'get',
        params: params,
      })
        .then((response) => {
          this.list = response.data.items
          this.total = response.data.total
          this.listLoading = false
        })
        .catch(() => {
          this.listLoading = false
        })
    },
    // 点击查询按钮
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    // 点击重置按钮
    handleReset() {
      this.listQuery = {
        page: 1,
        limit: 10,
        hotel_name: undefined,
        api_account_id: undefined,
        price_plan_id: undefined,
        distributor_res_id: undefined,
        crs_order_no: undefined,
        crs_order_status: undefined,
        hotel_id: undefined,
        roomtyp_id: undefined,
        product_id: undefined,
        rate_id: undefined,
        start_date: undefined,
        end_date: undefined,
        sort: 'id',
        order: 'DESC',
      }
      this.dateRange = null
      this.getList()
    },
    // 每页显示数量变化
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    // 当前页码变化
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    // 查看详情
    handleViewDetail(row) {
      this.currentRow = Object.assign({}, row)
      this.dialogDetailVisible = true
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.filter-container {
  margin-bottom: 10px;
}
.pagination-container {
  margin-top: 20px;
}
.detail-content {
  max-height: 600px;
  overflow: auto;
}
.operation-buttons {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 5px;
}
.json-section {
  margin-top: 15px;
  .json-label {
    font-weight: bold;
    margin-bottom: 8px;
  }
  .json-content {
    background-color: #f5f7fa;
    padding: 15px;
    border-radius: 4px;
    max-height: 150px;
    overflow: auto;
    pre {
      margin: 0;
      white-space: pre-wrap;
      word-wrap: break-word;
      font-size: 12px;
      line-height: 1.5;
      color: #333;
    }
  }
  .json-empty {
    text-align: center;
    padding: 15px;
    color: #999;
    background-color: #f5f7fa;
    border-radius: 4px;
  }
}
</style>
